<div *ngFor="let notification of notifications$ | async as notifications">
  <div class="alert alert-{{ notification.type }} {{ transition }}" ngxClipboard cbContent="{{ notification.context | json }}">
    {{ notification.message }}
    <span class="close" (click)="closeNotification(notification)">&#43;</span>
  </div>
</div>